module.exports = __webpack_public_path__ + "img/cassetta-di-sicurezza-per-chiavi.f127c484.png";